module.exports = __webpack_public_path__ + "static/media/top-friend-icon.422e97c6.svg";